
export default function ValuesHeroSection() {
  return (
    <section 
      className="relative py-6 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: 'url(/img/herobg.png)'
      }}
    >
      <div className="absolute inset-0 bg-white/70"></div>
      <div className="relative max-w-7xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-[#00889D] ">
          Our Values & Ethics
        </h1>
      </div>
    </section>
  );
}
